import { connect, useDispatch } from 'react-redux';
import { DataTestId, RouteName } from '@mews-commander/enums';
import { IconButton, IconName, Stack } from '@optimus-web/core';
import { useResolveRoute } from '@mews/routing';
import { startEntityDeleting } from '../../../../entityManagement';
import { closeSidebar } from '../../../actions';
import { openModal } from '../../../../app';

const ActionColumn = ({ openDeleteConfirmationDialog, restrictionId, serviceId }: $TSFixMe) => {
    const resolveRoute = useResolveRoute();
    const dispatch = useDispatch();

    const handleClickEditIcon = () => {
        const restrictionDetailUrl = resolveRoute(RouteName.RestrictionDetail, {
            restrictionId,
            query: { OwnerId: serviceId },
        });
        dispatch(closeSidebar(serviceId));
        dispatch(openModal(restrictionDetailUrl));
    };

    const handleClickDeleteIcon = () => {
        openDeleteConfirmationDialog();
    };

    return (
        <Stack vertical spacing="200">
            <IconButton
                data-test-id={DataTestId.RestrictionCalendarSidebarEditButton}
                icon={IconName.Edit}
                onClick={handleClickEditIcon}
                variant="ghost"
                type="submit"
            />
            <IconButton
                data-test-id={DataTestId.RestrictionCalendarSidebarDeleteButton}
                icon={IconName.Delete}
                onClick={handleClickDeleteIcon}
                variant="ghost"
                type="submit"
            />
        </Stack>
    );
};

// @ts-expect-error $TSFixMeError: Property 'restrictionId' does not exist on type '{}'.
export default connect(null, (dispatch, { restrictionId, serviceId }) => ({
    openDeleteConfirmationDialog: () => dispatch(startEntityDeleting(restrictionId, serviceId)),
}))(ActionColumn);
